module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/logo_cabal.f797e5ff.png";